import Breadcrumbs, { Crumb } from 'common/Breadcrumbs'

export default Breadcrumbs
export { Breadcrumbs, Crumb }
